import { render, staticRenderFns } from "./ChangeAccrual.vue?vue&type=template&id=b2c25bf2&scoped=true"
import script from "./ChangeAccrual.vue?vue&type=script&lang=js"
export * from "./ChangeAccrual.vue?vue&type=script&lang=js"
import style0 from "./ChangeAccrual.vue?vue&type=style&index=0&id=b2c25bf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c25bf2",
  null
  
)

export default component.exports